import moment, { type MomentInput } from 'moment';

export type PreciseDiff = {
  years: number;
  months: number;
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  firstDateWasLater: boolean;
};

export const getPreciseDiff = (firstDate: MomentInput, secondDate: MomentInput): PreciseDiff => {
  let firstMoment = moment(firstDate);
  let secondMoment = moment(secondDate);

  firstMoment.add(secondMoment.utcOffset() - firstMoment.utcOffset(), 'minutes');

  if (firstMoment.isSame(secondMoment)) {
    return {
      years: 0,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      firstDateWasLater: false,
    };
  }

  const firstDateWasLater = firstMoment.isAfter(secondMoment);

  if (firstDateWasLater) {
    [firstMoment, secondMoment] = [secondMoment, firstMoment];
  }

  let years = secondMoment.year() - firstMoment.year();
  let months = secondMoment.month() - firstMoment.month();
  let days = secondMoment.date() - firstMoment.date();
  let hours = secondMoment.hour() - firstMoment.hour();
  let minutes = secondMoment.minute() - firstMoment.minute();
  let seconds = secondMoment.second() - firstMoment.second();

  if (seconds < 0) {
    seconds += 60;
    minutes -= 1;
  }
  if (minutes < 0) {
    minutes += 60;
    hours -= 1;
  }
  if (hours < 0) {
    hours += 24;
    days -= 1;
  }
  if (days < 0) {
    const daysInLastFullMonth = moment(`${secondMoment.year()}-${secondMoment.month() + 1}`, 'YYYY-MM')
      .subtract(1, 'M')
      .daysInMonth();

    days =
      daysInLastFullMonth < firstMoment.date()
        ? daysInLastFullMonth + days + (firstMoment.date() - daysInLastFullMonth)
        : daysInLastFullMonth + days;
    months -= 1;
  }
  if (months < 0) {
    months += 12;
    years -= 1;
  }

  return { years, months, days, hours, minutes, seconds, firstDateWasLater };
};
